import sendPostHogEvent from "./sendPostHogEvent";

class RetryableError extends Error {
  constructor(message, options) {
    super(message, options);
  }
}

const submitWithRetries = async (
  formData,
  postHogSessionId,
  extraQueryParams,
  startTime,
  maxTime,
) => {
  let currTime = Date.now();
  let response = {};
  while (currTime < startTime + maxTime) {
    try {
      response = await submit(formData, postHogSessionId, extraQueryParams);
      if (response.status === 504 || response.body?.STATUS === "processing") {
        console.log(response.status, response.body?.STATUS, "retrying...");
        throw new RetryableError();
      } else {
        break;
      }
    } catch (error) {
      if (error instanceof RetryableError) {
        await new Promise((resolve) => setTimeout(resolve, 5000));
        currTime = Date.now();
      } else {
        throw error;
      }
    }
  }
  return response;
};

const submit = async (formData, postHogSessionId, extraQueryParams) => {
  const response = await fetch("/submit", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      postHogSessionId,
      extras: extraQueryParams,
      ...formData,
    }),
  });

  const result = {
    status: response.status,
    statusText: response.statusText,
  };

  if (response.status == 200 || response.status == 400) {
    result.body = await response.json();
  }

  sendPostHogEvent("server_response", result);
  return result;
};

export default submitWithRetries;
